import type { Definition } from '@exodus/dependency-types';
import type { BackedUpAtom } from '@passkeys/wallet-feature';

type Dependencies = {
  passkey: any;
  backedUpAtom: BackedUpAtom;
};

const createPairingApi = ({ passkey, backedUpAtom }: Dependencies) => {
  return {
    pairing: {
      start: async () => {
        const data = await passkey.shareWallet();

        if (data?.backedUp) {
          await backedUpAtom.set(true);
        }

        return data;
      },
    },
  };
};

const pairingApiDefinition = {
  id: 'pairingApi',
  type: 'api',
  factory: createPairingApi,
  dependencies: ['passkey', 'backedUpAtom'],
} as const satisfies Definition;

export default pairingApiDefinition;
